/* Cartes technologie et carte à révélation du simulateur — survol sur
   les appareils à pointeur.

   Le clic est déjà géré par le navigateur : la carte est un <details>, et
   son attribut `name` n'en laisse qu'une seule ouverte par grille. Ce
   fichier n'ajoute que ce que le HTML ne sait pas faire — l'ouverture au
   survol du prototype (usePdp.js, « cartes technologie »).

   Réservé à `(hover:hover)` : sur écran tactile, le survol simulé après un
   toucher rouvrirait la carte que l'on vient de fermer.

   Rien n'est fabriqué ici : le script ne fait que basculer l'attribut
   `open` de cartes déjà rendues en Liquid. Sans lui, la page reste
   entièrement utilisable au clic et au clavier. */
const POINTEUR = window.matchMedia('(hover:hover)');

const brancher = (grille) => {
  if (grille.dataset.survolBranche) return;
  grille.dataset.survolBranche = '1';

  const cartes = grille.querySelectorAll('.tech-card');
  const toutFermer = () => cartes.forEach((c) => { c.open = false; });

  /* Dans la grille du simulateur (.amb-suivi), la carte voisine avec le
     curseur : elle se referme dès que la souris la quitte, comme dans le
     prototype (ClubPage, AmbassadeurPage). Dans une grille de cartes, on
     attend la sortie de la grille entière pour ne pas clignoter entre
     deux cartes. */
  const parCarte = grille.classList.contains('amb-suivi');

  cartes.forEach((carte) => {
    carte.addEventListener('mouseenter', () => {
      if (!POINTEUR.matches) return;
      toutFermer();
      carte.open = true;
    });
    if (parCarte) {
      carte.addEventListener('mouseleave', () => {
        if (!POINTEUR.matches) return;
        carte.open = false;
      });
    }
  });

  /* La souris quitte la grille : on rend les cartes à leur état de repos.
     Sans ça, la dernière survolée resterait rose au milieu de la page. */
  if (!parCarte) {
    grille.addEventListener('mouseleave', () => {
      if (!POINTEUR.matches) return;
      toutFermer();
    });
  }
};

const brancherTout = () =>
  document.querySelectorAll('.tech-grid, .amb-suivi').forEach(brancher);

brancherTout();
/* L'éditeur de thème remplace le HTML d'une section sans recharger la page. */
document.addEventListener('shopify:section:load', brancherTout);
